import { render } from "./WhatsAppProvisioningView.vue?vue&type=template&id=4a56b7ca&scoped=true"
import script from "./WhatsAppProvisioningView.vue?vue&type=script&lang=js"
export * from "./WhatsAppProvisioningView.vue?vue&type=script&lang=js"

import "./WhatsAppProvisioningView.vue?vue&type=style&index=0&id=4a56b7ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a56b7ca"]])

export default __exports__